import * as betgalaxy from './AllSports.styles.betgalaxy';
import * as betprofessor from './AllSports.styles.betprofessor';
import * as betroyale from './AllSports.styles.betroyale';
import * as fiestabet from './AllSports.styles.fiestabet';
import * as puntcity from './AllSports.styles.puntcity';
import * as puntgenie from './AllSports.styles.puntgenie';
import * as questbet from './AllSports.styles.questbet';
import * as sterlingparker from './AllSports.styles.sterlingparker';
import * as vikingbet from './AllSports.styles.vikingbet';
import * as volcanobet from './AllSports.styles.volcanobet';
import * as wellbet from './AllSports.styles.wellbet';
import * as goldenrush from './AllSports.styles.goldenrush';
import * as juicybet from './AllSports.styles.juicybet';
import * as forsport from './AllSports.styles.forsport';
import * as junglebet from './AllSports.styles.junglebet';
import * as sugarcastle from './AllSports.styles.sugarcastle';
import * as oldgill from './AllSports.styles.oldgill';
import * as buffalobet from './AllSports.styles.buffalobet';
import * as titanbet from './AllSports.styles.titanbet';
import * as gigabet from './AllSports.styles.gigabet';
import * as slambet from './AllSports.styles.slambet';
import * as betstride from './AllSports.styles.betstride';
import * as templebet from './AllSports.styles.templebet';
import * as goldenbet888 from './AllSports.styles.goldenbet888';
import * as hyperbet from './AllSports.styles.hyperbet';
import * as bet777 from './AllSports.styles.bet777';
import * as chromabet from './AllSports.styles.chromabet';
import * as bet575 from './AllSports.styles.bet575';
import * as epicodds from './AllSports.styles.epicodds';
import * as pyramidbet from './AllSports.styles.pyramidbet';
import * as magnumbet from './AllSports.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  goldenrush,
  juicybet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
